/** Clickable table header for client-side column sorting. */
export default function SortableTh({
  label,
  sortKey,
  sort,
  onSort,
  className = '',
  align = 'left'
}) {
  const active = sort?.key === sortKey;
  const arrow = active ? (sort.dir === 'asc' ? ' ↑' : ' ↓') : '';

  return (
    <th
      className={`${align === 'right' ? 'text-right' : 'text-left'} ${className}`.trim()}
    >
      <button
        type="button"
        className={`inline-flex items-center gap-0.5 w-full ${
          align === 'right' ? 'justify-end' : 'justify-start'
        } font-medium text-[hsl(var(--ds-fg))] hover:text-[hsl(var(--ds-primary))] transition-colors ${
          active ? 'text-[hsl(var(--ds-primary))]' : ''
        }`}
        onClick={() => onSort(sortKey)}
      >
        <span>{label}</span>
        {active && (
          <span className="text-[10px] text-[hsl(var(--ds-primary))] font-semibold" aria-hidden>
            {arrow}
          </span>
        )}
      </button>
    </th>
  );
}
